import { ROUND_SIZE } from "./deck";

export type DiscoverSceneMode =
  | "card"
  | "interstitial"
  | "done"
  | "grid"
  | "empty";

export type DiscoverScene = {
  mode: DiscoverSceneMode;
  cursor: number;
  deckLength: number;
  totalLeft: number;
  roundPos: number;
  roundSize: number;
  showGrid: boolean;
  showInterstitial: boolean;
  allDone: boolean;
  currentGuestId: string | null;
  currentLabel: string | null;
};

export function buildDiscoverScene(input: {
  deck: readonly string[];
  cursor: number;
  roundPos: number;
  showGrid: boolean;
  currentGuestId: string | null;
  currentLabel: string | null;
}): DiscoverScene {
  const { deck, cursor, roundPos, showGrid, currentGuestId, currentLabel } =
    input;
  const totalLeft = deck.length - cursor;
  const allDone = totalLeft <= 0;
  const showInterstitial = !allDone && roundPos >= ROUND_SIZE;

  let mode: DiscoverSceneMode = "card";
  if (showGrid) mode = "grid";
  else if (allDone) mode = "done";
  else if (showInterstitial) mode = "interstitial";
  else if (!currentGuestId) mode = "empty";

  return {
    mode,
    cursor,
    deckLength: deck.length,
    totalLeft,
    roundPos,
    roundSize: ROUND_SIZE,
    showGrid,
    showInterstitial,
    allDone,
    currentGuestId,
    currentLabel,
  };
}

export function isPickleSceneDebugEnabled(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return localStorage.getItem("pickle_scene_debug") === "1";
  } catch {
    return false;
  }
}

export function logDiscoverScene(
  scene: DiscoverScene,
  reason: "mount" | "update" = "update",
): void {
  console.log(`[pickle-event] discover scene (${reason})`, scene);
}

declare global {
  interface Window {
    /** Dev, or prod after localStorage pickle_scene_debug=1 + reload. */
    logPickleScene?: () => DiscoverScene | undefined;
    __pickleDiscoverScene?: DiscoverScene;
  }
}
